module.exports = __webpack_public_path__ + "img/logo.16baf11c.png";